import React from "react";
import { ShiftGrade } from "./ShiftGrade";
import { ShiftGroup } from "./ShiftGroup";
import { ShiftCategory } from "./ShiftCategory";

export const EmployeeView = ({
  viewComponent,
  setIsViewPanelOpen,
  setUserData,
  userShiftGradeDetails,
  setUserShiftGradeDetails,
  userShiftGroupDetails,
  setUserShiftGroupDetails,
  userShiftCategoryDetails,
  setUserShiftCategoryDetails,
  trigger,
  setTrigger,
  setGradeData,
  setGroupData,
  setCategoryData,
  page,
  setPage,
}) => {
  const renderComponent = () => {
    switch (viewComponent) {
      case "ShiftGrade":
        return (
          <ShiftGrade
            setIsViewPanelOpen={setIsViewPanelOpen}
            setUserData={setUserData}
            userShiftGradeDetails={userShiftGradeDetails}
            setUserShiftGradeDetails={setUserShiftGradeDetails}
            trigger={trigger}
            setTrigger={setTrigger}
            setGradeData={setGradeData}
            page={page}
            setPage={setPage}
          />
        );
      case "ShiftGroup":
        return (
          <ShiftGroup
            setIsViewPanelOpen={setIsViewPanelOpen}
            setUserData={setUserData}
            userShiftGroupDetails={userShiftGroupDetails}
            setUserShiftGroupDetails={setUserShiftGroupDetails}
            trigger={trigger}
            setTrigger={setTrigger}
            setGroupData={setGroupData}
            page={page}
            setPage={setPage}
          />
        );
      case "ShiftCategory":
        return (
          <ShiftCategory
            setIsViewPanelOpen={setIsViewPanelOpen}
            setUserData={setUserData}
            userShiftCategoryDetails={userShiftCategoryDetails}
            setUserShiftCategoryDetails={setUserShiftCategoryDetails}
            trigger={trigger}
            setTrigger={setTrigger}
            setCategoryData={setCategoryData}
            page={page}
            setPage={setPage}
          />
        );
      default:
        break;
    }
  };

  return <React.Fragment>{renderComponent()}</React.Fragment>;
};
